import { store } from '@core/Store'
import { QUICKBET_MODAL_ID } from '@core/Areas/Quickbet/constants'
import { closeModal } from '@core/Components/Modal'
import { state$ as navState$ } from '@core/State/Navigation/driver'
import { isBetLoopRoute } from '@core/State/Navigation/helpers/isRouteCheck'
import { appHistory } from '@core/Utils/routing/history'
import { AppRoutes } from '@core/AppRoutes'
import { queryClient } from '@core/Data/ReactQuery'
import { queryKeys } from '@core/Data/ReactQuery/constants'

let lastUpdatedFeedTimestamp: number | null = null

export const navigateToLastBetLoopPath = () => {
  navState$.take(1).subscribe(navState => {
    store.dispatch(closeModal({ id: QUICKBET_MODAL_ID }))

    const lastBetLoopPath = navState.get('lastBetLoopPath')
    const currentUrlPath = navState.get('currentUrl')

    if (isBetLoopRoute(currentUrlPath)) {
      const cleanedPathUrl = cleanBetLoopPathUrl(currentUrlPath)
      const isMainBetLoopFeedPath = cleanedPathUrl === AppRoutes.BetLoop

      if (!isMainBetLoopFeedPath) {
        appHistory.push(AppRoutes.BetLoop)
        return
      }

      if (window.scrollY === 0) return
      window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })

      if (lastUpdatedFeedTimestamp && Date.now() - lastUpdatedFeedTimestamp < 30_000) return
      lastUpdatedFeedTimestamp = Date.now()

      const queryKey = queryKeys.betLoopSharedBetsFeedBase()
      queryClient.invalidateQueries({ queryKey, refetchType: 'active' })
    } else {
      // NOT in Bet Loop - Go to last used Bet Loop route
      appHistory.push(lastBetLoopPath)
    }
  })
}

// =============
// Local Helpers
// =============

function cleanBetLoopPathUrl(path: string) {
  return path.includes('?') ? path.slice(0, path.indexOf('?')) : path
}
